import WysiwygText from '~/components/WysiwygText';
import media from '~/utils/media';

const RoundText = ({ text }) => (
  <WysiwygText
    html={text}
    css={`
      max-width: 100%;
      p {
        line-height: 1.5;
      }

      ${media.tablet`
                 p {
                    line-height: 1.5;
                }
            `}

      ${media.desktop`
             p {
                line-height: 1.5;
            }
        `}
    `}
  />
);

export default RoundText;
